import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Proveedor } from '../models/t2_proveedores.model';
import { environment } from './../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ProveedoresService {

  constructor(private http: HttpClient) { }

  getToken(): string {
    return <string>localStorage.getItem('access_token');
  }

  // Método para crear headers con el token
  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Authorization': `Bearer ${this.getToken()}`
    });
  }

  // Métodos para paginación
  getPages(pageSize: number, proveedor: Proveedor): Observable<any> {
    const headers = this.getHeaders();
    let params = new HttpParams();
    params = params.append('index', proveedor.t2_razon);
    params = params.append('size', pageSize);
    return this.http.get<any>(`${environment.apiUrl}/proveedores/paginar`, { headers, params });
  }

  getDataId(proveedor: Proveedor): Observable<Proveedor> {
    const headers = this.getHeaders();
    return this.http.get<Proveedor>(`${environment.apiUrl}/proveedores/${proveedor.t2_id}`, { headers });
  }

  getDataFilter(page: any, filtro: Proveedor): Observable<Proveedor[]> {
    const headers = this.getHeaders();
    let params = new HttpParams();
    params = params.append('index', filtro.t2_razon);
    if(page!=0){
      params = params.append('size', page.size);
      params = params.append('offset', page.offset);
    }
    return this.http.get<Proveedor[]>(`${environment.apiUrl}/proveedores`, { headers, params });
  }

  postData(proveedor: Proveedor): Observable<any> {
    const headers = this.getHeaders();
    const formData = new FormData();
    formData.append('data', JSON.stringify(proveedor));
    return this.http.post<any>(`${environment.apiUrl}/proveedores`, formData, { headers });
  }

  putData(proveedor: Proveedor): Observable<any> {
    const headers = this.getHeaders();
    const formData = new FormData();
    formData.append('data', JSON.stringify(proveedor));
    return this.http.put<any>(`${environment.apiUrl}/proveedores/${proveedor.t2_id}`, formData, { headers });
  }

  deleteData(proveedor: Proveedor): Observable<any> {
    const headers = this.getHeaders();
    return this.http.delete<any>(`${environment.apiUrl}/proveedores/${proveedor.t2_id}`, { headers });
  }


}
